export default  {
  bindings: {
    categories: '<',
    pagedcategories: '<'
  },
  controller: 'categoryListController',
  template: require('../views/category.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/category.list.component.js